// ADR-0053 §2 / V101-4-3 (D-CI-12): declared over-privilege, recorded per
// connector. Pure helpers; the snapshot is stored in
// evidence_connectors.privilege_declaration_json (migration 282).
/**
 * Does the kind's declared over-privilege apply to these values (a create/update
 * body or a stored config)? Always for an unconditional declaration; for one with
 * `onlyWithFields` (D-CI-34), only when one of those fields is non-empty.
 */
export function privilegeApplies(manifest, values) {
    const p = manifest?.privilege;
    if (!p)
        return false;
    if (!p.onlyWithFields?.length)
        return true;
    return p.onlyWithFields.some((k) => {
        const v = values?.[k];
        return typeof v === 'string' ? v.trim().length > 0 : v != null && v !== false;
    });
}
/** Snapshot the manifest declaration at confirmation; null when the kind is read-only (or the declaration does not apply to `values`). */
export function snapshotPrivilege(manifest, confirmedBy, now, values) {
    const p = manifest?.privilege;
    if (!p)
        return null;
    if (p.onlyWithFields?.length && !privilegeApplies(manifest, values))
        return null;
    const at = now.toISOString();
    return { ...p, beyondReadOnly: [...p.beyondReadOnly], declared_at: at, confirmed_at: at, confirmed_by: confirmedBy };
}
export function parsePrivilegeSnapshot(json) {
    if (!json)
        return null;
    try {
        const v = JSON.parse(json);
        if (!Array.isArray(v.beyondReadOnly) || typeof v.confirmed_at !== 'string' || typeof v.revalidateDays !== 'number')
            return null;
        return v;
    }
    catch {
        return null;
    }
}
/** When the next re-confirmation is due. */
export function privilegeReviewDueAt(s) {
    return new Date(Date.parse(s.confirmed_at) + s.revalidateDays * 86_400_000);
}
export function isPrivilegeReviewDue(s, now) {
    return privilegeReviewDueAt(s).getTime() <= now.getTime();
}
//# sourceMappingURL=privilege.js.map